<template>
  <div class="member-item">
    <img width="300px" height="350px" :style="objfit" class="member-image" :src="require(`@/assets/team/${img}.jpeg`)" />
    <div style="margin-top: 3px;">
      <span class="member-name">{{ name }}</span>
      <p class="member-desc">{{desc}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'clubItem',
  props: {
    name: String,
    img: String,
    desc: String,
    objfit: String,
  }
}
</script>

